/* Draft PR 711: account-type presentation; Shopify retains all authentication. */
(function () {
  'use strict';
  if (window.__partifyBusinessAuthBound) return;
  window.__partifyBusinessAuthBound = true;

  function setMode(surface, mode) {
    const business = mode === 'business';
    surface.dataset.authSelected = business ? 'business' : 'personal';
    surface.querySelectorAll('[data-auth-personal]').forEach(function (panel) {
      panel.hidden = business;
      panel.inert = business;
    });
    surface.querySelectorAll('[data-auth-business]').forEach(function (panel) {
      panel.hidden = !business;
      panel.inert = !business;
    });
    surface.querySelectorAll('[data-auth-mode]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.authMode === mode));
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-auth-surface]').forEach(function (surface) {
      if (surface.hasAttribute('data-auth-ready')) return;
      const deepLink = surface.matches('.account-page') && new URLSearchParams(location.search).get('account_type') === 'business';
      setMode(surface, deepLink ? 'business' : 'personal');
      surface.setAttribute('data-auth-ready', '');
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-auth-mode]');
    if (button) {
      const surface = button.closest('[data-auth-surface]');
      if (!surface) return;
      const owner = surface.closest('[data-member-sidebar], [data-account-drawer]');
      const surfaces = owner ? owner.querySelectorAll('[data-auth-surface]') : [surface];
      surfaces.forEach(function (entry) { setMode(entry, button.dataset.authMode); });
      return;
    }

    const signup = event.target.closest('[data-auth-business-signup]');
    if (!signup) return;
    const dialog = document.getElementById('business-signup-dialog');
    if (!dialog || !document.documentElement.classList.contains('business-signup-ready')) {
      event.preventDefault();
      event.stopPropagation();
      location.assign('/pages/sign-up-for-a-wholesale-account');
      return;
    }
    if (dialog.open) return;
    // Suspend the originating overlay before the native modal's bubble listener runs.
    // Each controller returns a one-use resume callback for an already-open overlay.
    let resume;
    if (signup.closest('[data-member-sidebar]') && window.MemberSidebar) {
      resume = window.MemberSidebar.suspend(signup);
    } else if (signup.closest('[data-account-drawer]') && window.AccountDrawer) {
      resume = window.AccountDrawer.suspend(signup);
    }
    if (resume) {
      dialog.addEventListener('close', resume, { once: true, capture: true });
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
